import React from 'react'
import UpdatePrices from '../features/prices/UpdatePrices'

const Prices = () => {
  return (
    <>
    <div className="mb-10 flex items-center justify-between">
        <span className="text-3xl font-semibold">Update Room Settings</span>
     </div>
         <UpdatePrices/>
      </>
  )
}

export default Prices